export default "__VITE_ASSET__c4a4c2fa__"